const getIsProd = () => {
  if (
    typeof import.meta !== "undefined" &&
    import.meta.env?.MODE !== undefined
  ) {
    return (
      import.meta.env.MODE === "production" ||
      import.meta.env.VITE_ENV === "prod" ||
      import.meta.env.NEXT_PUBLIC_VITE_ENV === "prod"
    );
  }
  if (typeof process !== "undefined" && process.env) {
    return (
      process.env.NODE_ENV === "production" ||
      process.env.VITE_ENV === "prod" ||
      process.env.NEXT_PUBLIC_VITE_ENV === "prod"
    );
  }
  return false;
};

export const isProd = getIsProd();
export const isDev = !isProd;
